import React from 'react'

export default function PaymentIcon({ className, size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect
        x="2"
        y="5"
        width="20"
        height="14"
        rx="2"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M2 10H22"
        stroke="currentColor"
        strokeWidth="2"
      />
      <rect
        x="5"
        y="14"
        width="6"
        height="2"
        rx="1"
        fill="currentColor"
        opacity="0.5"
      />
      <circle cx="18" cy="15" r="1.5" fill="currentColor" />
    </svg>
  )
}
